import LoopIcon from '@mui/icons-material/Loop';

const icons = {
    LoopIcon
};

const reassignToVendor = {
    id: 'ReassigendGroup',
    type: 'group',
    children: [
        {
            id: 'ReassignVendor',
            title: 'Reassign Vendor',
            type: 'item',
            url: '/Reassigned-Vendor',
            icon: icons.LoopIcon,
            // breadcrumbs: false
        }
    ]
};

export default reassignToVendor;
